export const brandByModel = {
  Toyota: [
    "RAV4 L", "Corolla", "Aqua", "Harrier", "Passo",  
    "Sienta", "Vitz", "Axela", "Succeed","Fielder","Axio","Premio","ESQUIRE","Hiace"
  ],
  Mazda: [
    "Atenza", "CX-5","CX-8", "Demio", "Flair", "Flair Hybrid"," 6"
  ],
  Peugeot: ["308", "208","2008","3008"],
  Audi:["A3","A4","A5","A6","A7","Q3","Q5"],
  Subaru:["Impreza","Forester"],
  Honda: [
    "Fit Hybrid", "Fit", "N-Box", "Shuttle","Vezel","Grace","N Wagon"
  ],
  Daihatsu: ["Mira", "Move","HIJET"],
  Nissan: [
    "E-Power", "Dayz", "Note", "Xtrail","NV200","Ad Van","Cube","Lafesta","Sylphy", "Serena","Kicks","Skyline"
  ],
  Suzuki: [
    "Baleno", "Solio", "Wagon", "Carry", "Alto","Swift"
  ],
  Volvo: ["V60", "Xc90","V40","S60"],  
  Mitsubishi: ["Outlander","Mirage","RVR"],
  Volkswagen: ["Golf","Lutecia"],  
  BMW: ["X3","118i"],
  Mercedes: ["A180","B180", "C200", "C350","GLC250"],
  Isuzu: ["Elf","Canter"]
};
